import Mediator from "../services/Mediator";

export const applyCrop = (cropUrl) => () => {
  Mediator.applyCropToActiveObject(cropUrl);
};
